import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["size", "as"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import Base from '../Base';
import system from '../../system';
import styles from './index.module.scss';
/**
 * Note!
 *
 * This component is extended by Heading, Paragraph & Caption
 * Changes will also affect those components
 */

var SYSTEM_PROPS = ['colorProps', 'flexProps', 'marginProps', 'textProps', 'floatProps', 'displayProps'];
var Text = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _classnames;

  var size = _ref.size,
      as = _ref.as,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var classnames = (_classnames = {}, _classnames[styles.root] = true, _classnames[styles.heading1] = size === 'Heading1', _classnames[styles.heading2] = size === 'Heading2', _classnames[styles.heading3] = size === 'Heading3', _classnames[styles.heading4] = size === 'Heading4', _classnames[styles.heading5] = size === 'Heading5', _classnames[styles.heading6] = size === 'Heading6', _classnames[styles.paragraph] = size === 'Paragraph', _classnames[styles.caption1] = size === 'Caption1', _classnames[styles.caption2] = size === 'Caption2', _classnames);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  return /*#__PURE__*/React.createElement(Base, _extends({
    as: as,
    className: cx(classnames, className),
    ref: ref,
    style: style
  }, rest));
});
Text.displayName = 'Text';
Text.identifier = Text.displayName;
Text.clonableProps = SYSTEM_PROPS;
Text.defaultProps = {
  as: 'span',
  size: 'Heading6'
};
export default Text;